var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "535px",
    height: "374px",
    viewBox: "0 0 535 374",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leaderboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.156%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61A351",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DC87E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.156%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61A351",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DC87E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.156%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61A351",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DC87E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leaderboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    points: "0 115 200 115 190 260 10 260"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "66 135 106 135 106 175 66 175"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "104.667 155.5 100.6 150.85 101.167 144.7 95.15 143.333 92 138 86.333 140.433 80.667 138 77.517 143.317 71.5 144.667 72.067 150.833 68 155.5 72.067 160.15 71.5 166.317 77.517 167.683 80.667 173 86.333 170.55 92 172.983 95.15 167.667 101.167 166.3 100.6 160.15"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(80.808000, 150.117000)",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.153,11.883 L9.248,11.883 L9.248,9.282 L4.607,9.282 L6.443,7.973 C8.483,6.579 9.129,5.372 9.129,3.825 C9.129,1.598 7.293,0 4.675,0 C2.754,0 1.241,0.799 -1.52020044e-23,2.295 L1.819,4.097 C2.703,3.162 3.519,2.635 4.607,2.635 C5.457,2.635 6.154,3.145 6.154,3.944 C6.154,4.658 5.78,5.304 4.471,6.29 L0.153,9.52 L0.153,11.883 Z",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#316B23",
    fillRule: "nonzero",
    points: "30 80 170 80 200 115 0 115"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(335.000000, 120.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-2)",
    points: "0 35 200 35 190 140 10 140"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#316B23",
    points: "30 0 170 0 200 35 0 35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(422.000000, 175.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "38.667 20.5 34.6 15.85 35.167 9.7 29.15 8.333 26 3 20.333 5.433 14.667 3 11.517 8.317 5.5 9.667 6.067 15.833 2 20.5 6.067 25.15 5.5 31.317 11.517 32.683 14.667 38 20.333 35.55 26 37.983 29.15 32.667 35.167 31.3 34.6 25.15"
  }), /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(15.655000, 15.117000)",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.845,12.104 C7.667,12.104 9.486,10.642 9.486,8.585 C9.486,7.089 8.364,6.171 7.072,5.865 C8.381,5.491 9.231,4.505 9.231,3.196 C9.231,1.36 7.582,0 4.828,0 C2.669,0 1.241,0.901 0.238,2.074 L1.87,3.842 C2.635,3.094 3.485,2.601 4.522,2.601 C5.576,2.601 6.273,3.026 6.273,3.74 C6.273,4.42 5.644,4.811 4.471,4.794 L3.094,4.794 L3.094,7.242 L4.471,7.225 C5.95,7.225 6.511,7.599 6.511,8.33 C6.511,9.01 5.865,9.503 4.692,9.503 C3.604,9.503 2.516,9.078 1.666,8.228 L0,10.149 C1.037,11.305 2.686,12.104 4.845,12.104 Z",
    id: "Path"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(168.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-3)",
    points: "0 35 200 35 190 260 10 260"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.000000, 117.000000)",
    fill: "#37652C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.48462739,88.5009821 C2.69283325,89.0388385 2.84435773,89.564458 2.95397915,90.0578852 C3.42220851,89.8287738 3.94562271,89.6135936 4.51673907,89.4392657 C4.33659329,88.5760975 4.35698362,87.674901 4.58258674,86.8115445 C4.02493923,87.5397309 3.3034208,88.1176865 2.48462739,88.5009821 M44.8104663,63.2840464 L32.1628487,41.5092408 L6.55128262,86.3318602 C5.8033877,87.7097289 5.91282205,89.4048142 6.85002904,90.6601262 C6.87322538,90.6913772 6.88613302,90.7075675 6.88613302,90.7075675 C3.71496878,90.8681526 1.54442732,92.9999991 1.54442732,92.9999991 C1.54442732,92.9999991 1.84990816,89.9633791 0,87.3663442 L0,87.3663442 C0.0110369685,87.3663442 0.202780913,87.3657795 0.51873752,87.3328341 C1.8199774,87.1965345 2.97175054,86.4226012 3.60160602,85.2685726 L31.9778391,35.62859 L47.0966153,61.2563071 C46.2594893,61.8815158 45.5005575,62.571862 44.8104663,63.2840464",
    id: "Shape",
    transform: "translate(23.548308, 64.314295) scale(-1, 1) rotate(-180.000000) translate(-23.548308, -64.314295) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2847826,54.3115396 C60.5485474,55.1524932 60.6014874,56.0454063 60.4475311,56.9036798 C61.0328646,57.0798903 61.5678769,57.2992122 62.0460208,57.5330301 C62.1509656,57.0601231 62.2944462,56.5578477 62.4895573,56.0433355 C61.6196946,55.6756654 60.8558989,55.0792604 60.2847826,54.3115396 M63.4555727,60.475144 C63.4555727,60.475144 61.2850312,58.3434857 58.113867,58.1827124 C58.113867,58.1827124 58.1260264,58.1674634 58.1482874,58.1377185 C59.0527576,56.9281535 59.1148639,55.2797564 58.3218858,53.9933817 L57.9144533,53.2638775 C57.9077189,53.2706548 57.9004232,53.2772439 57.8938759,53.2840212 L49.4328236,38.7170935 C49.5549785,38.4970186 49.6776946,38.2752493 49.8045262,38.0455731 C50.1446145,37.4305305 50.5073379,36.7744474 50.9014887,36.0731821 C50.9881008,35.9193744 51.0767707,35.7736618 51.1656276,35.6287023 L61.448528,53.0594281 C62.0016859,53.9449991 62.9037243,54.5545822 63.9281046,54.7311693 C64.5620755,54.8403596 64.9829769,54.8414891 64.9994388,54.8414891 L65,54.8414891 C63.1499048,57.438524 63.4555727,60.475144 63.4555727,60.475144",
    id: "Shape",
    transform: "translate(57.216412, 48.051923) scale(-1, 1) rotate(-180.000000) translate(-57.216412, -48.051923) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7811785,64.7441255 C35.7652778,64.4534534 35.7480676,64.1614635 35.7284255,63.867591 C35.7181368,63.7145363 35.7082223,63.5680707 35.6981206,63.4184047 C42.1309897,61.5561452 46.9324451,54.2639273 46.9324451,45.5452699 C46.9324451,35.4173045 40.4552411,27.2067585 32.4650371,27.2067585 C24.4748331,27.2067585 17.9976291,35.4173045 17.9976291,45.5452699 C17.9976291,54.6161602 23.1945448,62.143702 30.0191327,63.6175828 C30.0135206,63.7017347 30.0080957,63.7824978 30.0022966,63.867591 C29.9794744,64.2085283 29.9596453,64.5470182 29.9418739,64.8838138 C21.1328765,63.5592225 14.351314,55.4083546 14.351314,45.5452699 C14.351314,34.7583975 22.461054,26.0141368 32.4650371,26.0141368 C42.4690202,26.0141368 50.5787602,34.7583975 50.5787602,45.5452699 C50.5787602,55.1101522 44.2005148,63.0635362 35.7811785,64.7441255",
    id: "Path",
    transform: "translate(32.465037, 45.448975) scale(-1, 1) rotate(-180.000000) translate(-32.465037, -45.448975) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3086279,6.27059258 C33.7112605,8.05208885 33.9428498,8.82658697 34.7895162,21.4514334 C35.6361827,34.0764681 32.8653424,43.9903828 32.8653424,43.9903828 C32.8653424,43.9903828 30.0946891,34.0764681 30.9413556,21.4514334 C31.788022,8.82658697 32.0196113,8.05208885 30.4222439,6.27059258 C30.4222439,6.27059258 28.016746,5.84456214 26.2850643,7.16124659 L26.2850643,4.64403358 L32.8653424,4.64403358 L39.4458075,4.64403358 L39.4458075,7.16124659 C37.7141258,5.84456214 35.3086279,6.27059258 35.3086279,6.27059258",
    id: "Path",
    transform: "translate(32.865436, 24.317208) scale(-1, 1) rotate(-180.000000) translate(-32.865436, -24.317208) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4948876,43.7408273 L34.329892,43.7351795 C34.3469151,44.7094206 34.3469151,45.2450178 34.3469151,45.2450178 L31.3839567,45.2450178 C31.3839567,45.2450178 31.3839567,44.7094206 31.4009798,43.7351795 L31.4948876,43.7408273 Z",
    id: "Path",
    transform: "translate(32.865436, 44.490099) scale(-1, 1) rotate(-180.000000) translate(-32.865436, -44.490099) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9620616,59.2591767 C33.6032666,59.3410694 33.3243493,59.4783103 33.0819101,59.6876545 C32.8832447,59.75411 32.3656296,59.8109642 31.8455826,59.8262132 L31.8455826,59.8254602 C31.8455826,59.8254602 31.7686979,58.2570733 30.9029507,57.5599497 C30.9029507,57.5599497 31.1530596,55.7010789 32.8654733,55.6622975 C34.577887,55.7010789 34.827996,57.5599497 34.827996,57.5599497 C34.2978473,57.9867331 34.0642003,58.7390167 33.9620616,59.2591767",
    id: "Path",
    transform: "translate(32.865473, 57.744255) scale(-1, 1) rotate(-180.000000) translate(-32.865473, -57.744255) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4949811,67.9861348 C31.4949811,67.9861348 29.0995848,67.6956509 29.0705894,66.2434199 C29.0705894,66.2434199 29.1860099,65.3721566 29.9941405,65.0235006 L29.4746547,65.0235006 C29.4746547,65.0235006 29.0995848,64.8201808 29.0705894,64.1812292 C29.041781,63.5422777 29.6766873,63.2228019 30.2827853,63.106646 C30.2827853,63.106646 29.272622,63.048474 29.272622,62.4095224 C29.272622,61.7705709 29.6910915,61.3057591 30.0231359,61.1024392 L29.6766873,61.1024392 C29.6766873,61.1024392 29.4890589,60.8846234 29.5612668,60.3618277 C29.6334748,59.8390321 30.6002384,59.4903762 31.4949811,59.4613842 C31.4949811,59.4613842 33.2870855,59.4758802 33.6537373,59.1274125 C34.0203892,58.7789449 34.6696997,58.7062768 36.8054466,58.8951007 C36.8054466,58.8951007 37.9310303,59.1564044 40.7016835,57.2975337 C43.4723368,55.4386629 47.8014474,42.5427233 60.5581253,47.1899003 C60.5581253,47.1899003 53.4213221,45.2640092 49.0301052,53.0763871 C45.3705083,59.5873296 44.4035576,62.230488 39.2105704,64.2683932 C39.2105704,64.2683932 38.3927123,64.6168609 37.6423855,65.4301404 C36.8920587,66.2434199 35.5837103,67.8699789 34.592815,67.9861348 L31.4949811,67.9861348 Z",
    id: "Path",
    transform: "translate(44.813885, 57.086233) scale(-1, 1) rotate(-180.000000) translate(-44.813885, -57.086233) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0696915,36.5090215 C27.48598,36.3203859 27.3340814,36.1675194 27.14664,34.5737175 C26.9591986,36.1675194 26.8073,36.3203859 25.2235885,36.5090215 C26.8073,36.6976572 26.9591986,36.8505236 27.14664,38.4443255 C27.3340814,36.8505236 27.48598,36.6976572 29.0696915,36.5090215",
    id: "Path",
    transform: "translate(27.146640, 36.509021) scale(-1, 1) rotate(-180.000000) translate(-27.146640, -36.509021) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7884687,1.93530399 C33.2047572,1.74666833 33.0528586,1.59380191 32.8654172,-1.42108547e-14 C32.6779758,1.59380191 32.5260772,1.74666833 30.9423657,1.93530399 C32.5260772,2.12393965 32.6779758,2.27680608 32.8654172,3.87060798 C33.0528586,2.27680608 33.2047572,2.12393965 34.7884687,1.93530399",
    id: "Path",
    transform: "translate(32.865417, 1.935304) scale(-1, 1) rotate(-180.000000) translate(-32.865417, -1.935304) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7580789,32.6384285 C38.1743674,32.4497928 38.0224688,32.2969264 37.8350274,30.7031245 C37.647586,32.2969264 37.4956874,32.4497928 35.9119759,32.6384285 C37.4956874,32.8270642 37.647586,32.9799306 37.8350274,34.5737325 C38.0224688,32.9799306 38.1743674,32.8270642 39.7580789,32.6384285",
    id: "Path",
    transform: "translate(37.835027, 32.638428) scale(-1, 1) rotate(-180.000000) translate(-37.835027, -32.638428) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.14664,21.0888269 C26.0809178,20.9619402 25.9787791,20.8589625 25.8526958,19.7866384 C25.7266124,20.8589625 25.6242866,20.9619402 24.5585644,21.0888269 C25.6242866,21.2157135 25.7266124,21.3186913 25.8526958,22.3910154 C25.9787791,21.3186913 26.0809178,21.2157135 27.14664,21.0888269",
    id: "Path",
    transform: "translate(25.852602, 21.088827) scale(-1, 1) rotate(-180.000000) translate(-25.852602, -21.088827) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1290278,15.4966852 C38.0633056,15.3697985 37.9611669,15.2668207 37.8350835,14.1944967 C37.7090002,15.2668207 37.6066744,15.3697985 36.5409522,15.4966852 C37.6066744,15.6235718 37.7090002,15.7265496 37.8350835,16.7988736 C37.9611669,15.7265496 38.0633056,15.6235718 39.1290278,15.4966852",
    id: "Path",
    transform: "translate(37.834990, 15.496685) scale(-1, 1) rotate(-180.000000) translate(-37.834990, -15.496685) "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "115.667 75.5 111.6 70.85 112.167 64.7 106.15 63.333 103 58 97.333 60.433 91.667 58 88.517 63.317 82.5 64.667 83.067 70.833 79 75.5 83.067 80.15 82.5 86.317 88.517 87.683 91.667 93 97.333 90.55 103 92.983 106.15 87.667 112.167 86.3 111.6 80.15"
  }), /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(93.473000, 70.321000)",
    fill: "#3F3D56"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "3.128 11.679 6.018 11.679 6.018 0 3.706 0 0 2.482 1.156 4.505 3.128 3.281"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#316B23",
    points: "30 0 170 0 200 35 0 35"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.63b875958a9ba5b51332318a5505718d.svg";
export { ForwardRef as ReactComponent };